module.exports = __webpack_public_path__ + "static/media/hdi-agent.0122feb1.svg";